import {Component, OnInit} from '@angular/core';
import {IMsfFormBuilder} from '@components/form-builder/form-builder';


import {buildFilterQuery} from '@app/utils/_msf';

@Component({
  selector: 'app-list-table-filters-wrapper-page',
  template: '',
})
export abstract class ListTableFiltersWrapperParent<ModelType, ServiceType> implements  OnInit{
  abstract service: ServiceType;

  abstract getAllMethod: string;
  abstract getTotalMethod: string | undefined
  abstract storageKey: string
  abstract filtersForms: IMsfFormBuilder[] ;

  data: ModelType[] = [];
  loading = false;
  filterModel: any = {};
  toggleFilter: boolean | undefined = undefined;
  filtersParams:Object[] = [];


  ngOnInit() {
    this.loadMetadata();
  }

  protected  loadMetadata() {}

  protected  applyFilters() {
    this.toggleFilter = !this.toggleFilter;
    const filters = {...this.filterModel};
    this.filtersParams = buildFilterQuery(filters);

  }

  protected  clearFilters() {
    this.filtersParams = [];
    this.filterModel = {};
    this.toggleFilter = !this.toggleFilter;
  }


  protected export() {
  }


  protected  create() {
  }

  onRowClick(data: any) {}
}
